import classNames from 'classnames'

import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  category?: SIZES
  countryCode: string
  countryLabel?: string
}

const FlagCountry = ({ category = 'small', countryCode, countryLabel }: Props): ReactElement => {
  const flagClasses = classNames('flag-country-icon fi', { [`fi-${countryCode.toLowerCase()}`]: true })
  const classes = classNames('flag-country', category)

  return (
    <div className={classes}>
      <span className={flagClasses} />
      {countryLabel ? <div className="flag-country-label">{countryLabel}</div> : null}
    </div>
  )
}

export default FlagCountry
